import Box from "../../components/Box";
import Textfield from "../../components/Merchant/Textfield";
import Selectfield from "../../components/Merchant/Selectfield";
import Button from "../../components/Button";
import styled from "styled-components";
import { AMD_RENEWAL_PERIOD_OPTIONS, Colors } from "../../config/Constants";

type Props = {
  handleCancel: () => void;
  handleConfigureSubmit: () => void;
  handleConfigureChange: (event: any) => void;
  configureData: {
    renewalGracePeriod: string | number | undefined;
    email: string;
    phoneNumber: string;
    price: string;
    percentage: string;
    validity: string;
  };
  configureError: {
    email: string;
    phoneNumber: string;
    price: string;
    percentage: string;
    validity: string;
    renewalGracePeriod: string;
  };
  validityDropdownValues: (
    | { label: string; value: string }
    | { label: string; value: number }
  )[];
};

const AMDForm = ({
  handleCancel,
  handleConfigureSubmit,
  handleConfigureChange,
  configureData,
  configureError,
  validityDropdownValues,
}: Props) => {
  return (
    <Box>
      <FormContainer>
        <Textfield
          name="email"
          required
          label="Email"
          placeholder="Enter Email"
          value={configureData.email}
          onChange={handleConfigureChange}
          helperText={configureError.email}
        />
        <Textfield
          name="phoneNumber"
          required
          label="Phone Number"
          placeholder="+974XXXXXXXX"
          value={configureData.phoneNumber}
          onChange={handleConfigureChange}
          helperText={configureError.phoneNumber}
        />
        <Textfield
          name="price"
          required
          label="Price"
          placeholder="Enter Price"
          value={configureData.price}
          onChange={handleConfigureChange}
          helperText={configureError.price}
        />
        <Selectfield
          label="Validity"
          data={validityDropdownValues}
          name="validity"
          value={configureData.validity}
          onChange={handleConfigureChange}
          helperText={configureError.validity}
        />
        <Selectfield
          data={AMD_RENEWAL_PERIOD_OPTIONS}
          name="renewalGracePeriod"
          label="Renewal Period"
          required
          value={configureData?.renewalGracePeriod}
          onChange={(e) => handleConfigureChange(e)}
          helperText={configureError.renewalGracePeriod}
        />
        <TextFieldWrapper>
          <Textfield
            name="percentage"
            required
            label="Discount for Renewal Price"
            placeholder="Enter Discount Percentage"
            value={configureData.percentage}
            onChange={handleConfigureChange}
            helperText={configureError.percentage}
          />
          <PercentageIcon>%</PercentageIcon>
        </TextFieldWrapper>

        <div />
        <ActionContainer>
          <Button width="150px" onClick={handleCancel} label="Cancel" />
          <Button
            width="150px"
            variant="filled"
            color={Colors.red}
            onClick={handleConfigureSubmit}
            label="Save"
          />
        </ActionContainer>
      </FormContainer>
    </Box>
  );
};

const TextFieldWrapper = styled.div`
  position: relative;
`;
const PercentageIcon = styled.div`
  position: absolute;
  right: 0.7rem;
  bottom: 0.7rem;
`;
const FormContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ActionContainer = styled.div`
  justify-content: end;
  display: flex;
  gap: 1rem;
`;

export default AMDForm;
